<div class="list-container" *ngIf="!isEdit">
    <div class="list-content">
        <div class="list-details">
            <h4 class="list-details-title">Location List</h4>
            <table class="table table-striped">
                <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">City</th>
                    <th scope="col">Country</th>
                    <th scope="col">State</th>
                    <th scope="col">postal Code</th>
                    <th scope="col">Action</th>
                </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let list of locationList | paginate : {
                        itemsPerPage: tableSize,
                        currentPage: pageNumber,
                        totalItems: totalRecords
                        };let i = index">
                        <th scope="col">{{list.locationId}}</th>
                        <td scope="col">{{list.city}}</td>
                        <td scope="col">{{list.country}}</td>
                        <td scope="col">{{list.provinceOrState}}</td>
                        <td scope="col">{{list.postalCode}}</td>
                        <td scope="col">{{list.isActive}}</td>
                        <td>
                            <i class="bi bi-pencil-square" (click)="getLocationById(list.industryId)"></i>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="pagination-block" *ngIf="locationList.length != 0">
                <pagination-controls
                    previousLabel="Prev"
                    nextLabel="Next"
                    (pageChange)="onTableDataChange($event)"
                >
                </pagination-controls>
            </div>
        </div>
    </div>
</div>


<div class="list-container" *ngIf="isEdit">
    <div class="list-content">
        <div class="list-details">
            <h4 class="list-details-title">Update Location</h4>
            <div [formGroup]="locationUpdateForm">
                <div class="form-group">
                    <label>City</label>
                    <input formControlName="city" type="text" class="form-control">
                    <span class="err" *ngIf="locationUpdateForm.get('city').invalid && formSubmit">city required</span>
                </div>
                <div class="form-group">
                    <label>Country</label>
                    <input formControlName="country" type="text" class="form-control">
                    <span class="err" *ngIf="locationUpdateForm.get('country').invalid && formSubmit">country required</span>
                </div>
                <div class="form-group">
                    <label>Province or State</label>
                    <input formControlName="provinceOrState" type="text" class="form-control">
                    <span class="err" *ngIf="locationUpdateForm.get('provinceOrState').invalid && formSubmit">province or state required</span>
                </div>
                <div class="form-group">
                    <label>Postal Code</label>
                    <input formControlName="postalCode" type="text" class="form-control">
                    <span class="err" *ngIf="locationUpdateForm.get('postalCode').invalid && formSubmit">postal code required</span>
                </div>
                <div class="form-group isActive-checkbox">
                    <input formControlName="isActive" type="checkbox" class="">
                    <label>Active Status</label>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" (click)="closeEdit()" class="btn btn-danger">Cancel</button>
                <button type="button" (click)="updateLocation()" class="btn btn-primary">Update</button>
            </div>
        </div>
    </div>
</div>